"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports["default"] = void 0;
var _types = require("../../actions/types/types.generic");
var initialState = exports.initialState = [];
var _default = exports["default"] = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  //Attendee presence does not seem to work consistently
  if (action.type === "".concat(_types.BROADCAST_SET_ATTENDEE_PRESENCE)) {
    var _action$payload = action.payload,
      attendeeId = _action$payload.attendeeId,
      presence = _action$payload.presence;
    if (!presence) {
      return state.filter(function (a) {
        return a !== attendeeId;
      });
    } else if (!state.includes(attendeeId)) {
      return state.concat([attendeeId]);
    }
  }
  return state;
};